import React, { useEffect, useState } from "react";
import { Card, Typography, Box, Grid } from "@mui/material";
import axios from "axios";

import {
  AppWidgetSummary,
  AppCurrentVisits,
} from "../sections/@dashboard/app";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";

export default function ZoneDashboard({ zonaId }) {

  const [zone, setZone] = useState(null);
  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

  useEffect(() => {
    if (zonaId) getZone();
  }, [zonaId]);

  const getZone = async () => {
    try {
      const res = await axios.get(`${SERVER_URL}/api/zonas/${zonaId}`);
      setZone(res.data);
    } catch (err) {
      console.log("error");
    }
  };

  if (!zone) return null;

  return (
    <Card sx={{ backgroundColor: "#002855", color: "#ff9800" }}>

      <Typography sx={{ ml: 2, mt: 1, fontSize: '1rem', fontWeight: 600 }}>
        Pregled zone
      </Typography>

      <Box sx={{ p: 2 }}>

        {/* 🔥 RED 1 */}
        <Grid container spacing={3}>

          {/* GRAF */}
          <Grid item xs={12} md={6}>
            <Card sx={{ backgroundColor: "#001B44", color: "#ff9800", height: '100%' }}>
              <Box sx={{ p: 2 }}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                  Ukupna potrošnja po mjesecima
                </Typography>

                <div style={{ width: '100%', height: 300 }}>
                  <ResponsiveContainer>
                    <LineChart
                      data={[
                        { name: 'Jan', value: zone.januar },
                        { name: 'Feb', value: zone.februar },
                        { name: 'Mar', value: zone.mart },
                        { name: 'Apr', value: zone.april },
                        { name: 'Maj', value: zone.maj },
                        { name: 'Jun', value: zone.juni },
                        { name: 'Jul', value: zone.juli },
                        { name: 'Aug', value: zone.august },
                        { name: 'Sep', value: zone.septembar },
                        { name: 'Okt', value: zone.oktobar },
                        { name: 'Nov', value: zone.novembar },
                        { name: 'Dec', value: zone.decembar },
                      ]}
                    >
                      <CartesianGrid stroke="#444" strokeDasharray="3 3" />
                      <XAxis dataKey="name" stroke="#fff" />
                      <YAxis stroke="#fff" />
                      <Tooltip />
                      <Line type="monotone" dataKey="value" stroke="#ffeb3b" strokeWidth={2} />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </Box>
            </Card>
          </Grid>

          {/* WIDGETI */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={3}>

              <Grid item xs={12} sm={4}>
                <AppWidgetSummary
                  title="Ukupno lampi"
                  total={zone.numbertotal}
                  icon={'mdi:lightbulb-group'}
                  sx={{ bgcolor: '#E3F2FD', '& svg': { color: '#1565C0' } }}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <AppWidgetSummary
                  title="Uključeno lampi"
                  total={zone.numberaktivne}
                  icon={'mdi:lightbulb-on'}
                  sx={{
                    bgcolor: '#FFF3C4',
                    '& svg': { color: '#E6A800' }
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <AppWidgetSummary
                  title="Isključeno lampi"
                  total={zone.numberneaktivne}
                  icon={'mdi:lightbulb-off'}
                  sx={{ bgcolor: '#F5F5F5', '& svg': { color: '#757575' } }}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <AppWidgetSummary
                  title="Lampe pod alarmom"
                  total={zone.numberalarms}
                  icon={'mdi:alert-circle'}
                  sx={{ bgcolor: '#FFE0B2', '& svg': { color: '#E65100' } }}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <AppWidgetSummary
                  title="Lampe bez konekcije"
                  total={zone.numberfailed}
                  icon={'mdi:signal-off'}
                  sx={{ bgcolor: '#FFEBEE', '& svg': { color: '#C62828' } }}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <AppWidgetSummary
                  title="Lampe sa kvarom"
                  total={zone.numberfailed}
                  icon={'mdi:lightbulb-alert'}
                  sx={{ bgcolor: '#FFCDD2', '& svg': { color: '#B71C1C' } }}
                />
              </Grid>

            </Grid>
          </Grid>

        </Grid>

        {/* 🔥 RED 2 */}
        <Grid container spacing={3} sx={{ mt: 2 }}>

          <Grid item xs={12} sm={6} md={3}>
            <AppCurrentVisits
              title="Modeli lampi"
              chartData={[
                { label: 'S 45 W', value: zone.number45w },
                { label: 'M 60 W', value: zone.number60w },
                { label: 'L 90 W', value: zone.number90w },
              ]}
              chartColors={['#FFF3C4', '#FFE082', '#FFB74D']}
              chartHeight={200}
              sx={{ bgcolor: '#EAF3FF' }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppCurrentVisits
              title="Status lampi"
              chartData={[
                { label: 'Uključeno', value: zone.numberaktivne },
                { label: 'Isključeno', value: zone.numberneaktivne },
              ]}
              chartColors={['#FFD54F', '#BDBDBD']}
              chartHeight={200}
              sx={{ bgcolor: '#EAF3FF' }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppCurrentVisits
              title="Ukupna potrošnja po mjesecima"
              chartData={[
                { label: 'Januar', value: zone.januar },
                { label: 'Februar', value: zone.februar },
                { label: 'Mart', value: zone.mart },
              ]}
              chartColors={['#AEDFF7', '#C8E6C9', '#FFE0B2']}
              chartHeight={200}
              sx={{ bgcolor: '#EAF3FF' }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppCurrentVisits
              title="Status alarma u zadnjih 30 dana"
              chartData={[
                { label: 'Riješeni', value: zone.numberaktivne },
                { label: 'Neriješeni', value: zone.numberalarms },
              ]}
              chartColors={['#A5D6A7', '#EF9A9A']}
              chartHeight={200}
              sx={{ bgcolor: '#EAF3FF' }}
            />
          </Grid>

        </Grid>

      </Box>
    </Card>
  );
}